import { render, staticRenderFns } from "./drawingPad.vue?vue&type=template&id=13f570a3"
import script from "./drawingPad.vue?vue&type=script&lang=js"
export * from "./drawingPad.vue?vue&type=script&lang=js"
import style0 from "./drawingPad.vue?vue&type=style&index=0&id=13f570a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports